import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentBlock from "../Layout/ContentBlock";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import { ButtonInfo, CheckBoxInput, SelectForm } from "../common/Buttons";
import { IconEye, IconEyeInvisible } from "../Layout/Icons";
import { DebounceSelect } from "../common";
import ButtonWithRetailHistory from "./ButtonWithRetailHistory";
import {
  antdMessageInfo,
  exportDocument,
  formatDatePlus,
  getDateFormat,
} from "../../helpers/Utils";
import {
  exportImumToRivile,
  getImums,
  getImumsOptions,
  getImumXls,
  imumMassChangePriceToOldPrice,
} from "../../redux/Actions/imum_action_retail";
import errorHandler from "../../helpers/ErrorHandler";
import Axios from "axios";
import useDebounce from "../../hooks/useDebounce";
import SwitchComp from "../common/SwitchComp";
import SelectInput from "../common/SelectInput";
import RetailProductTable from "./RetailProductTable";
import ImumModalPreliminaryPreview from "../ImumToAkeneoScreen/ImumModalPreliminaryPreview";
import { Label } from "../globals";
import Spinner from "../common/Spinner";
import DataPickerInputModal from "../common/DataPickerInputModal";
import { getLocalStorage, setLocalStorage } from "../../utils/localstorage";
import { AnimatePresence, motion } from "framer-motion";
import InstructionButton from "../InstructionButton/InstructionButton";
import ImumTagImport from "../ImumToAkeneoScreen/ImumTagImport";
import ImumBulkTagAction from "../ImumToAkeneoScreen/ImumBulkTagAction";
import RetailPriceImport from "./RetailPriceImport";
import {
  QueryClient,
  QueryClientProvider,
} from "react-query";

export const queryClient = new QueryClient();


const filterInitial = {
  departments: [],
  product_code: "",
  product_name: "",
  changed_price: false,
  failure_date: null,
  family_name: "",
  brand: [],
  competitor: [],
  cheapest_competitor: "",
  price_changes: "",
  table_sort: {
    lang: "",
    sort: "",
    type: "",
  },
  product_active: "",
  tag_ids: [],
  imum_rule_ids: [],
  tag_status: false,
  imum_prices_export_date: null,
  imum_prices_imum_rule_ids: [],
  no_competition: false,
  user: "",
  show_frozen: false,
  show_changed_not_exported: false,
  show_no_new_price: false,
};
const defaultLangs = ["LT", "LV", "EE", "FI"];

const RetailExport = ({
  page,
  setPage,
  failed = false,
  record_type,
  modal,
  totalLength,
}) => {
  console.log({ failed });
  const dispatch = useDispatch();
  const user_id = useSelector((state) => state.auth.user.id);
  const { current, loading, data, options, totals } = useSelector(
    (state) => state.retail
  );
  const [filters, setFilters] = useState(filterInitial);
  const [filterString, setfilterString] = useState("");
  const [hiddenFilters, setHiddenFilters] = useState(false);
  const [checked, setChecked] = useState([]);
  const [bulkTagModalVisible, setBulkTagModalVisible] = useState(false);
  const isInitialMount = useRef(true);
  const [hasMore, setHasMore] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [preliminaryPreview, setPreliminaryPreview] = useState({
    preview: false,
    record: {},
  });

  useEffect(() => {
    if (current !== "imum") return;
    // hacking with dom elements
    const items = document
      .querySelector(".select_with_hidden_items")
      .querySelectorAll(".ant-select-selection-item");
    if (items.length < 3)
      return items.forEach((d) => (d.style.display = "flex"));
    items.forEach((d) => (d.style.display = "none"));
    [...items]
      .slice(items.length - 3, items.length)
      .forEach((d) => (d.style.display = "flex"));
  }, [filters?.competitor?.length]);
  console.log(filters);
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useDebounce(
    () => {
      console.log("DEBOUNCE table sort");
      onFilter();
    },
    1000,
    [
      filters?.table_sort?.sort,
      filters?.table_sort?.lang,
      filters?.table_sort?.type,
    ]
  );

  useEffect(() => {
    dispatch(getImumsOptions());
    Axios.get("/api/v1/also_incomes/vv_retail_stores")
      .then((res) => {
        const stores = res.data.stores || {};
        const options = Object.entries(stores).map(([code, label]) => ({
          label: label,
          value: code,
        }));
        setDepartmentOptions(options);
      })
      .catch((err) => console.error("Fetching departments error:", err));
    getLocalStorage("retail_hidden_filters").then((hidden_filters) => {
      if (typeof hidden_filters == "boolean") {
        setHiddenFilters(hidden_filters);
      }
    });
  }, []);

  useEffect(() => {
    dispatch({
      type: "LOADING_CUSTOM",
    });
  }, [filterString]);

  const trig = async () => {
    try {
      const { success, has_more } = await dispatch(
        getImums(
          page,
          filterString,
          preliminaryPreview?.preview ? "ImumModal" : "Imum"
        )
      );
      if (success) setHasMore(has_more);
      console.log({ success, has_more });
    } catch (err) {
      console.log({ err });
    }
  };


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (!!filterString) {
        trig();
      } else if (!failed) {
        trig();
      }
    }
  }, [filterString, page]);

  useEffect(() => {
    if (modal == "") {
      onFilter(true);
    }
  }, [modal]);

  useEffect(() => {
    dispatch({
      type: "LOADING_CUSTOM",
    });
    onFilter(true);
  }, [preliminaryPreview?.preview, failed]);

  // Functions
  const onFilter = (force = false) => {
    let filterParams = "";
    if (filters.departments?.length > 0) {
      filters.departments.forEach((d) => {
        filterParams += `&q[prices_department_in][]=${d}`;
      });
    }

    if (failed) {
      filterParams += `&q[retail_product_log_errors_id_not_null]=1`;
    }

    // TODO: no_competition needs a BE scope on RetailProduct/RetailProductStat

    // TODO: failure_date filter needs retail export_logs BE scope
    if (!failed && filters.imum_prices_export_date) {
      filterParams += `&q[prices_export_date_gteq]=${filters.imum_prices_export_date
        }&q[prices_export_date_lteq]=${formatDatePlus(
          filters.imum_prices_export_date
        )}`;
    }

    // TODO: failed rule filter needs retail export_logs BE scope
    if (
      !failed &&
      !!filters.imum_prices_imum_rule_ids &&
      filters.imum_prices_imum_rule_ids.length > 0
    ) {
      filters.imum_prices_imum_rule_ids.forEach((s) => {
        filterParams += `&q[prices_imum_rule_id_in][]=${s}`;
      });
    }

    if (filters.tag_ids?.length > 0) {
      if (filters.tag_ids.includes("")) {
        filterParams += `&q[tag_ids_blank]=${filters.tag_status ? "0" : "1"}`;
      } else {
        if (filters.tag_status) {
          filterParams += `&q[tag_ids_not_cont_any][]=${filters.tag_ids
            .map((id) => "-%20" + id + "%0A")
            .join(
              `&q[tag_ids_not_cont_any][]=`
            )}`;
        } else {
          filterParams += `&q[tag_ids_raw_cont_any][]=${filters.tag_ids
            .map((id) => "-%20" + id + "%0A")
            .join(
              `&q[tag_ids_raw_cont_any][]=`
            )}`;
        }
      }
    }
    //
    if (filters.product_code)
      filterParams += `&q[vv_sku_eq]=${filters.product_code}`;
    if (filters.product_name)
      filterParams += `&q[vv_sku_eq]=${filters.product_name}`;
    if (filters.brand) {
      filters.brand.forEach((brand) => {
        filterParams += `&q[brand_cont_any][]=${brand}`;
      });
    }

    if (filters.family_name) {
      if (filters.family_name === "no_category") {
        filterParams += `&q[category_null]=1`;
      } else {
        filterParams += `&q[category_cont_any]=${encodeURIComponent(filters.family_name)}`;
      }
    }
    if (!failed && filters.changed_price) {
      filterParams += `&q[prices_changed_price_true]=1`;
      filterParams += `&q[prices_price_type_eq]=new_price`;
    }
    if (filters.show_frozen) {
      filterParams += `&q[prices_price_type_eq]=freeze`;
    }
    if (filters.show_changed_not_exported) {
      filterParams += `&q[prices_changed_price_true]=1&q[prices_export_date_null]=1&q[prices_price_type_eq]=new`;
    }
    if (filters.show_no_new_price) {
      filterParams += `&q[prices_price_type_eq_none]=new`;
    }

    if (filters.competitor) {
      filters.competitor.forEach((d) => {
        filterParams += `&q[imum_supplier_prices_shop_in][]=${d}`;
      });
    }

    // TODO: cheapest_competitor needs a BE scope on RetailProduct stats

    // TODO: user filter needs retail export_logs endpoint

    // TODO: table_sort by stat columns needs BE scope support

    // TODO: price_changes filter needs BE scopes on RetailProductStat (stat_type='change')
    // TODO: product_active (active/inactive states) needs BE scope on RetailProductStat (stat_type='active')
    if (filters.product_active == "out_of_stock") {
      filterParams += `&q[imum_supplier_prices_active_false]=1&q[imum_supplier_prices_category_in][]=tch`;
    }
    if (preliminaryPreview?.preview) {
      filterParams = `&imums_ids=${checked.join(",")}`;
    }

    if (force && filterString == filterParams && page == 1) {
      trig();
    } else {
      setfilterString(filterParams);
      setPage(1);
    }
    setChecked([]);
  };

  const fetchOptions4Filter = async (value, type) => {
    try {
      let api_url = `/api/v1/retail_products/brands.json?per_page=20&q[brand_i_cont_any]=${value}`;
      if (type === "user" && value?.length < 3) {
        return [
          {
            label: "No data available",
            value: "",
          },
        ];
      }
      if (type === "family") {
        api_url = `/api/v1/retail_products/categories.json?per_page=20&q[category_i_cont_any]=${value}`;
      } else if (type === "product_code") {
        api_url = `/api/v1/retail_products.json?per_page=20&q[vv_sku_eq]=${value}`;
      } else if (type === "product_name") {
        api_url = `/api/v1/retail_products.json?per_page=20&q[product_title_i_cont_any]=${value}`;
      } else if (type === "user" && value?.length >= 3) {
        api_url = `/api/v1/users?q[firstname_i_cont]=${value}&q[deleted_at_null]=true`;
      }

      const { data } = await Axios.get(api_url);
      const valArr = data?.data || [];

      const options = [
        {
          label: "No data selected",
          value: "",
        },
        ...valArr.map((e) => {
          if (type === "user") {
            return {
              value: e.id,
              label: `${e.firstname} ${e.lastname}`,
            };
          } else if (["product_name", "product_code"].includes(type)) {
            return {
              value: e.product_code,
              label: `${e.product_code} - ${e.product_name}`,
            };
          } else {
            const val = e;
            return {
              value: val,
              label: val,
            };
          }
        }),
      ];

      if (type === "family") {
        options.splice(1, 0, {
          label: "No Category",
          value: "no_category",
        });
      }

      return options;
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  if (!["Imum", "ImumModal"].includes(current)) {
    return <Spinner />;
  }

  return (
    <div className="row">
      <ContentBlock containerClass="pt-3">
        <TableFilterBox
          mr={1}
          add={false}
          filter={!hiddenFilters}
          onFilter={() => onFilter()}
          clearFilter={
            hiddenFilters
              ? null
              : () => {
                setFilters(filterInitial);
              }
          }
          button1={
            <>
              <RenderCustomButton
                departmentOptions={departmentOptions}
                filterString={filterString}
                checked={checked}
                page={page}
                preliminaryPreview={preliminaryPreview}
                setPreliminaryPreview={setPreliminaryPreview}
                user_id={user_id}
                failed={failed}
                setBulkTagModalVisible={setBulkTagModalVisible}
              />
              <ButtonInfo
                className={"mr-3"}
                onClick={() => {
                  setHiddenFilters((prev) => !prev);
                  setLocalStorage("retail_hidden_filters", !hiddenFilters);
                }}
              >
                {hiddenFilters ? (
                  <span>
                    <IconEye color="#1F1A54" /> Show
                  </span>
                ) : (
                  <span>
                    <IconEyeInvisible color="#1F1A54" /> Hide
                  </span>
                )}{" "}
                filter
              </ButtonInfo>
            </>
          }
        >
          <AnimatePresence>
            {!hiddenFilters && (
              <motion.div
                className="d-flex flex-wrap"
                initial={{ height: 0 }}
                animate={{ height: "auto" }}
                exit={{ height: 0 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
              >
                <div className="px-1">
                  <SelectInput
                    mode="multiple"
                    options={departmentOptions}
                    label="Departments"
                    value={filters.departments || undefined}
                    onChange={(departments) => {
                      setFilters((prev) => ({
                        ...prev,
                        departments,
                      }));
                    }}
                    style={{ width: "200px" }}
                  />
                </div>
                <div className="px-1">
                  <DebounceSelect
                    label="SKU"
                    showSearch={true}
                    value={filters.product_code || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "product_code")}
                    onChange={(val) => {
                      setFilters((prev) => ({
                        ...prev,
                        product_code: val.value,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>

                <div className="px-1">
                  <DebounceSelect
                    label="Prod. title"
                    showSearch={true}
                    value={filters.product_name || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "product_name")}
                    onChange={(val) => {
                      setFilters((prev) => ({
                        ...prev,
                        product_name: val.value,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>

                <div className="px-1">
                  <DebounceSelect
                    label="Product category"
                    showSearch={true}
                    value={filters.family_name || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "family")}
                    onChange={(val) => {
                      setFilters((prev) => ({
                        ...prev,
                        family_name:
                          val.value === "no_category"
                            ? "no_category"
                            : val.value,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>

                <div className="px-1">
                  <DebounceSelect
                    label="Brand"
                    isMultiple={true}
                    showSearch={true}
                    value={filters.brand || undefined}
                    placeholder={"Enter"}
                    fetchOptions={(d) => fetchOptions4Filter(d, "brand")}
                    onChange={(val) => {
                      const brandValues = val.map((item) => item.value);
                      setFilters((prev) => ({
                        ...prev,
                        brand: brandValues,
                      }));
                    }}
                    style={{
                      width: "165px",
                    }}
                  />
                </div>
                <div className="px-1">
                  <SelectInput
                    with_empty={true}
                    mode="multiple"
                    options={options?.imum_product_tags || []}
                    label="Special tag"
                    filterByLabel={true}
                    style={{
                      width: "165px",
                    }}
                    extra_label={
                      <div
                        className="SwitchCompContainer"
                        style={{ height: "14.5px" }}
                      >
                        <SwitchComp
                          className=""
                          classNameContainer="SwitchCompInnerContainer"
                          checkedChildren={<IconEyeInvisible color="#fff" />}
                          unCheckedChildren={<IconEye color="#fff" />}
                          checked={filters.tag_status}
                          onChange={(value) =>
                            setFilters((prev) => ({
                              ...prev,
                              tag_status: value,
                            }))
                          }
                          inlineText={filters.tag_status ? "Exclude" : "Show"}
                        />
                      </div>
                    }
                    value={filters.tag_ids || undefined}
                    onChange={(tag_ids) => {
                      let val = tag_ids;
                      if (val.includes("No special tag")) {
                        val = ["No special tag"];
                      }
                      setFilters((prev) => ({
                        ...prev,
                        tag_ids: val,
                      }));
                    }}
                  />
                </div>

                <div className="px-1">
                  <SelectForm
                    className={"select_with_hidden_items"}
                    placeholder="Competitor"
                    style={{ width: "165px" }}
                    dropdownMatchSelectWidth={false}
                    options={options?.shops || []}
                    onChange={(competitor) =>
                      setFilters((prev) => ({ ...prev, competitor }))
                    }
                    value={filters.competitor || undefined}
                  />
                </div>

                <div className="px-1">
                  <SelectForm
                    placeholder="Price changes"
                    options={[
                      { label: "All", value: "" },
                      { label: "Positive changes", value: "positive_changes" },
                      { label: "Negative changes", value: "negative_changes" },
                      { label: "No changes", value: "no_changes" },
                    ]}
                    selector="price_changes"
                    style={{ width: "165px" }}
                    value={filters?.price_changes || undefined}
                    onChange={(price_changes) =>
                      setFilters((prev) => ({ ...prev, price_changes }))
                    }
                  />
                </div>

                <div className="px-1">
                  <SelectForm
                    placeholder="Products"
                    options={[
                      { label: "All", value: "" },
                      { label: "Active", value: "active" },
                      { label: "Inactive", value: "inactive" },
                      { label: "Out of stock", value: "out_of_stock" },
                    ]}
                    selector="product_active"
                    style={{ width: "165px" }}
                    value={filters?.product_active || undefined}
                    onChange={(product_active) =>
                      setFilters((prev) => ({ ...prev, product_active }))
                    }
                  />
                </div>

                <div className="d-flex flex-column justify-content-end px-1" style={{ gap: 4 }}>
                  <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <CheckBoxInput
                      checked={filters.show_frozen}
                      onChange={() =>
                        setFilters((prev) => ({ ...prev, show_frozen: !prev.show_frozen }))
                      }
                    />
                    <Label className="text-sm-label mb-0">Show frozen</Label>
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <CheckBoxInput
                      checked={filters.show_changed_not_exported}
                      onChange={() =>
                        setFilters((prev) => ({ ...prev, show_changed_not_exported: !prev.show_changed_not_exported }))
                      }
                    />
                    <Label className="text-sm-label mb-0">Changed not exported</Label>
                  </div>
                </div>

                <div className="d-flex flex-column justify-content-end px-1" style={{ gap: 4 }}>
                  <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <CheckBoxInput
                      checked={filters.show_no_new_price}
                      onChange={() =>
                        setFilters((prev) => ({ ...prev, show_no_new_price: !prev.show_no_new_price }))
                      }
                    />
                    <Label className="text-sm-label mb-0">No new price</Label>
                  </div>
                </div>

                <div className="px-1">
                  <SelectInput
                    with_empty={true}
                    mode="multiple"
                    style={{ width: "165px" }}
                    options={options?.imum_rules || []}
                    label="Rule"
                    value={filters.imum_prices_imum_rule_ids || undefined}
                    onChange={(imum_prices_imum_rule_ids) => {
                      setFilters((prev) => ({
                        ...prev,
                        imum_prices_imum_rule_ids,
                      }));
                    }}
                  />
                </div>

                <div className="px-1">
                  <DataPickerInputModal
                    text="Export date"
                    classNameLabel="text-sm-label"
                    name="imum_prices_export_date"
                    value={getDateFormat(filters.imum_prices_export_date)}
                    onChange={(_, imum_prices_export_date) =>
                      setFilters((prev) => ({
                        ...prev,
                        imum_prices_export_date,
                      }))
                    }
                    style={{ width: "165px" }}
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </TableFilterBox>
        <div>
          <ContentValidation
            loader={false}
            array={current == "Imum" ? data : []}
          >
            <RetailProductTable
              data={current == "Imum" ? data : []}
              checked={checked}
              filterString={filterString}
              setChecked={setChecked}
              competitor={filters.competitor}
              table_sort={filters.table_sort}
              setFilters={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  [e.name]: e.value,
                }))
              }
              page={page}
              loading={loading}
              lastBookElementRef={lastBookElementRef}
              hasMore={hasMore}
              imum_product_tags={options?.imum_product_tags || []}
              retail_product_rules={options?.imum_rules || []}
              failed={failed}
              totalLength={totalLength}
              departmentOptions={departmentOptions}
              selectedDepartments={filters.departments || []}
            />
          </ContentValidation>
        </div>
      </ContentBlock>
      {data?.length > 0 && !loading && !hasMore && (
        <div className="col-12">
          <p
            className="mb-0 text-sm text-center py-1"
            style={{
              color: "#797979",
            }}
          >
            Nothing to show more...
          </p>
        </div>
      )}
      <div>
        <InstructionButton />
      </div>

      <ImumBulkTagAction
        visible={bulkTagModalVisible}
        onClose={() => setBulkTagModalVisible(false)}
        checkedProductIds={checked}
        imumProductTags={options?.imum_product_tags || []}
        endpoint="/api/v1/retail_products/bulk_tag_action"
        filterString={filterString}
        totalFilteredCount={totals || totalLength || 0}
        onSuccess={() => {
          setChecked([]);
          onFilter(true);
        }}
      />
    </div>
  );
};

const RenderCustomButton = ({
  departmentOptions,
  filterString,
  checked,
  preliminaryPreview,
  setPreliminaryPreview,
  user_id,
  failed,
  setBulkTagModalVisible,
}) => {
  const dispatch = useDispatch();

  const [importTagModal, setImportTagModal] = useState(false);
  const [importFreezeModal, setImportFreezeModal] = useState(false);
  const [importDiscountModal, setImportDiscountModal] = useState(false);
  const [importRrpModal, setImportRrpModal] = useState(false);

  return (
    <>
      <div className="float-left ml-1">
        <ButtonWithRetailHistory
          targetOptions={departmentOptions}
          actions={[
            {
              label: " Export selected prices",
              onClick: async (departments) => {
                if (checked.length == 0) return antdMessageInfo("Not selected");
                try {
                  dispatch(
                    exportImumToRivile(
                      departments,
                      "ids",
                      checked,
                      filterString,
                    ),
                  );
                } catch (err) {
                  console.log(err);
                }
              },
              type: "default",
            },
            {
              label: " Change to old price",
              onClick: (departments) =>
                imumMassChangePriceToOldPrice(departments, checked),
              type: "default",
            },
          ]}
        />
      </div>
      <div className="float-right mr-3">
        <button
          className="btn btn-sm btn-dark"
          type="button"
          onClick={() => setBulkTagModalVisible(true)}
        >
          <i className="fa fa-tags mr-1"></i>
          Bulk Tag Management
        </button>
      </div>
      <div className="dropdown">
        <button
          className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Export
        </button>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenuButton"
        >
          <button
            className="dropdown-item"
            onClick={() =>
              getImumXls({
                type: "get_imum_xls",
                ids: checked,
                filter: null,
                failed,
              })
            }
          >
            Export selected (XLS)
          </button>
          <button
            className="dropdown-item"
            onClick={() =>
              getImumXls({
                type: "get_imum_xls",
                filter: filterString,
                failed,
              })
            }
          >
            Export filtered (XLS)
          </button>
          <button
            className="dropdown-item"
            onClick={() =>
              exportDocument(
                `/api/v1/retail_products/download_xlsx`,
                `retail_data_${user_id}.xlsx`,
                "POST",
                {
                  file_name: `retail_data_${user_id}.xlsx`,
                }
              )
            }
          >
            Download your last generated
          </button>
        </div>
      </div>
      <div className="dropdown">
        <button
          className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Import
        </button>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenuButton"
        >
          <button
            className="dropdown-item"
            onClick={() => setImportTagModal(true)}
          >
            Import tags
          </button>
          <button
            className="dropdown-item"
            onClick={() => setImportFreezeModal(true)}
          >
            Import freeze prices
          </button>
          <button
            className="dropdown-item"
            onClick={() => setImportDiscountModal(true)}
          >
            Import discount prices
          </button>
          <button
            className="dropdown-item"
            onClick={() => setImportRrpModal(true)}
          >
            Import RRP prices
          </button>
        </div>
      </div>
      {preliminaryPreview?.preview && (
        <ImumModalPreliminaryPreview
          preliminaryPreview={preliminaryPreview}
          setPreliminaryPreview={setPreliminaryPreview}
        />
      )}

      {importTagModal && (
        <QueryClientProvider client={queryClient}>
          <ImumTagImport
            onClose={() => {
              setImportTagModal(false);
            }}
          />
        </QueryClientProvider>
      )}

      {importFreezeModal && (
        <RetailPriceImport
          importType="freeze"
          onClose={() => {
            setImportFreezeModal(false);
          }}
        />
      )}

      {importDiscountModal && (
        <RetailPriceImport
          importType="discount"
          onClose={() => {
            setImportDiscountModal(false);
          }}
        />
      )}

      {importRrpModal && (
        <RetailPriceImport
          importType="rrp"
          onClose={() => {
            setImportRrpModal(false);
          }}
        />
      )}
    </>
  );
};

export default RetailExport;
